export var AllIntegrationsItemViewType;
(function (AllIntegrationsItemViewType) {
    AllIntegrationsItemViewType["DynamicSnippet"] = "dynamic_snippet";
    AllIntegrationsItemViewType["NativeIntegration"] = "native_integrations_catalog";
})(AllIntegrationsItemViewType || (AllIntegrationsItemViewType = {}));
//# sourceMappingURL=all-integrations.js.map